import * as amplitude from '@amplitude/analytics-browser';
import { AnalyticsProvider } from '../AnalyticsProvider';

export default class AmplitudeProvider implements AnalyticsProvider {
  name = 'amplitude';

  private amplitudeInstance;

  constructor(apiKey: string) {
    this.amplitudeInstance = amplitude;

    amplitude.init(apiKey, {
      autocapture: true,
      defaultTracking: true,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track(eventName: string, properties?: Record<string, any>): void {
    this.amplitudeInstance.logEvent(eventName, properties);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async forceTrack(eventName: string, properties?: Record<string, any>): Promise<void> {
    await this.amplitudeInstance.logEvent(eventName, properties).promise;
  }

  setUserId(userId: string): void {
    this.amplitudeInstance.setUserId(`user_id_${userId}`);
  }

  reset(): void {
    this.amplitudeInstance.reset();
  }
}
